// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"b111715c","453":"f9eb393d"}[chunkId] + ".chunk.js";
};